import React from "react";
import { Link } from "react-router-dom";

/**
 * Functional component for rendering a login link or button on the top right.
 *
 * @param {string} text - The text to display.
 * @param {string} href - The URL for the link.
 * @param {function} onClick - The function to call when the button is clicked.
 * @param {string} linkText - The text to display for the link or button.
 * @return {JSX.Element} A div containing the login link or button.
 */
const LoginRightTop = ({ text = "", href, onClick, linkText }) => {
  return (
    <div className="">
      <p className="flex items-center justify-center text-right !text-base text-black">
        {text}
        {href == null ? (
          <button
            className="transition-linear before:transition-linear relative ml-2 font-semibold text-primary before:absolute before:bottom-0 before:right-0 before:h-[1px] before:w-0 before:bg-primaryHover before:content-[''] hover:text-primaryHover hover:before:w-full"
            onClick={onClick}
          >
            {linkText}
          </button>
        ) : (
          <Link
            to={href}
            className="authLink transition-linear ml-2 font-bold !text-primary hover:text-primaryHover"
          >
            {linkText}
          </Link>
        )}
      </p>
    </div>
  );
};

export default LoginRightTop;
